import React from 'react';
import { Link } from 'react-router-dom';

const Footer = () => {
  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-content">
          <div className="footer-section">
            <div className="footer-logo">
              <img src="https://codeflarelimited.com/assets/images/codeflare-app.webp" alt="CodeFlare" className="footer-logo-image" />
              <span className="logo-text">Codeflare</span>
            </div>
            <p>Learn to code interactively, for free.</p>
            <div className="app-download">
              <h4>Download Our App</h4>
              <div className="download-buttons">
                <button className="download-btn ios">
                  <span className="download-icon">
                    <i className="fa-brands fa-apple"></i>
                  </span>
                  <div className="download-text">
                    <span>Download on the</span>
                    <strong>App Store</strong>
                  </div>
                </button>
                <button className="download-btn-android">
                  <span className="download-icon">
                    <i className="fa-brands fa-google-play"></i>
                  </span>
                  <div className="download-text">
                    <span>Get it on</span>
                    <strong>Google Play</strong>
                  </div>
                </button>
              </div>
            </div>
          </div>
          
          <div className="footer-section">
            <h4>Subjects</h4>
            <ul>
              <li><a href="#">Web Development</a></li>
              <li><a href="#">Data Science</a></li>
              <li><a href="#">Computer Science</a></li>
              <li><a href="#">Developer Tools</a></li>
              <li><a href="#">Machine Learning</a></li>
            </ul>
          </div>
          
          <div className="footer-section">
            <h4>Languages</h4>
            <ul>
              <li><a href="#">HTML & CSS</a></li>
              <li><a href="#">Python</a></li>
              <li><a href="#">JavaScript</a></li>
              <li><a href="#">Java</a></li>
              <li><a href="#">SQL</a></li>
            </ul>
          </div>
          
          <div className="footer-section">
            <h4>Company</h4>
            <ul>
              <li><a href="https://codeflarelimited.com/about-us">About</a></li>
              <li><a href="#">Careers</a></li>
              <li><a href="#">Affiliates</a></li>
              <li><a href="https://codeflarelimited.com/contact">Contact</a></li>
              <li><a href="/plans">Pricing</a></li>
            </ul>
          </div>
          
          <div className="footer-section">
            <h4>Resources</h4>
            <ul>
              <li><a href="#">Blog</a></li>
              <li><a href="#">Community</a></li>
              <li><a href="#">Cheatsheets</a></li>
              <li><a href="#">Articles</a></li>
              <li><a href="#">Help Center</a></li>
            </ul>
          </div>
        </div>
      </div>
      <div className="footer-bottom">
        <div className="footer-links">
          <a href="#">Privacy Policy</a>
          <a href="#">Terms of Service</a>
          <a href="#">Cookie Policy</a>
        </div>
        <div className="text-muted">
          &copy; {new Date().getFullYear()} Codeflare. All rights reserved.
        </div>
      </div>

      <style jsx>{`
        .footer {
          background: #1a1a1a;
          color: white;
          padding: 60px 0 30px;
          font-family: 'Urbanist', sans-serif;
        }
        
        .footer-content {
          display: grid;
          grid-template-columns: 2fr 1fr 1fr 1fr 1fr;
          gap: 3rem;
          margin-bottom: 3rem;
        }
        
        .footer-logo {
          display: flex;
          align-items: center;
          gap: 12px;
          font-weight: 700;
          font-size: 1.5rem;
          margin-bottom: 1rem;
        }
        
        .footer-logo-image {
          width: 40px;
          height: 40px;
          border-radius: 8px;
        }
        
        .footer-section h4 {
          margin-bottom: 1.5rem;
          font-size: 1.1rem;
          font-family: 'Urbanist', sans-serif;
        }
        
        .footer-section ul {
          list-style: none;
        }
        
        .footer-section ul li {
          margin-bottom: 0.8rem;
        }
        
        .footer-section a {
          color: #ccc;
          text-decoration: none;
          transition: color 0.2s;
          font-family: 'Urbanist', sans-serif;
        }
        
        .footer-section a:hover {
          color: white;
        }
        
        .app-download {
          margin-top: 2rem;
        }
        
        .app-download h4 {
          margin-bottom: 1rem;
          font-size: 1rem;
          color: #ccc;
        }
        
        .download-buttons {
          display: flex;
          flex-direction: column;
          gap: 0.8rem;
        }
        
        .download-btn {
          display: flex;
          align-items: center;
          gap: 12px;
          padding: 12px 16px;
          border: 1px solid #333;
          border-radius: 8px;
          background: #2a2a2a;
          color: white;
          cursor: pointer;
          transition: all 0.2s;
          width: 100%;
          font-family: 'Urbanist', sans-serif;
        }

        .download-btn-android {
          display: flex;
          align-items: center;
          gap: 12px;
          padding: 12px 16px;
          border: 1px solid #333;
          border-radius: 8px;
          background: linear-gradient(135deg, #3DDC84, #3686F7, #FDBD00, #FF3A2E);
          color: white;
          cursor: pointer;
          transition: all 0.2s;
          width: 100%;
          font-family: 'Urbanist', sans-serif;
        }
        
        .download-btn:hover {
          background: #333;
          border-color: #555;
        }
        
        .download-icon {
          font-size: 1.5rem;
        }
        
        .download-text {
          display: flex;
          flex-direction: column;
          align-items: flex-start;
          line-height: 1.2;
        }
        
        .download-text span {
          font-size: 0.8rem;
          color: #ccc;
        }
        
        .download-text strong {
          font-size: 1rem;
        }
        
        .footer-bottom {
          display: flex;
          justify-content: space-between;
          align-items: center;
          padding-top: 2rem;
          border-top: 1px solid #333;
          font-size: 0.9rem;
          color: #999;
          max-width: 1400px;
          margin: 0 auto;
          padding: 2rem 20px 0;
        }
        
        .footer-links {
          display: flex;
          gap: 2rem;
        }
        
        .footer-links a {
          color: #999;
          text-decoration: none;
          font-family: 'Urbanist', sans-serif;
        }

        /* Responsive Footer */
        @media (max-width: 1200px) {
          .footer-content {
            grid-template-columns: 1fr 1fr 1fr;
            gap: 2rem;
          }
        }
        
        @media (max-width: 768px) {
          .footer-content {
            grid-template-columns: 1fr 1fr;
            gap: 2rem;
          }
          
          .footer-bottom {
            flex-direction: column;
            gap: 1rem;
            text-align: center;
          }
          
          .footer-links {
            flex-wrap: wrap;
            justify-content: center;
          }
        }
        
        @media (max-width: 576px) {
          .footer-content {
            grid-template-columns: 1fr;
            gap: 2rem;
          }
          
          .download-buttons {
            flex-direction: row;
          }
          
          .download-btn, .download-btn-android {
            flex: 1;
            min-width: 140px;
          }
          
          .footer-bottom {
            padding: 2rem 15px 0;
          }
        }
        
        @media (max-width: 480px) {
          .footer {
            padding: 40px 0 20px;
          }
          
          .footer-content {
            gap: 1.5rem;
          }
          
          .footer-links {
            flex-direction: column;
            gap: 1rem;
          }
        }
      `}</style>
    </footer>
  );
};

export default Footer;